import React, {useState} from 'react';
import {MdSearch, MdOutlineEmail, MdOutlineTextsms} from "react-icons/md";
import { sendFollowup, getTicketInfo } from '../../utils/awsAPI';
import { useSelector } from 'react-redux';
import followUpsARN from '../../config/followUpsARN.json'

const FollowupsInfo: React.FC<{ticket: any, setTicket: Function, setLastAction: Function, setAlertDisplay: Function, setFollowupAlert: Function}> = (props) => {
    const [ticketInput, setTicketInput] = useState("");
    const [ticketSearch, setTicketSearch] = useState("");
    const agentSliceData = useSelector((state:any)=>{return state.agentSlice});
    const accountName = agentSliceData.agentAccount;
    const queueARN = (followUpsARN?.filter((item: any) => item.accountName === accountName))[0]?.queueARN;

    return(
        <div className="card wrapup-box collapse show mt-3" id="followupBox">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className='m-0'>Follow-ups</h6>
            </div>
            <div className="card-body height-400">
                <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <input maxLength={20} onChange={(event) => { setTicketInput(event.target.value) }} value={ticketInput} type="text" placeholder='Type the ticket number' className='searchBar' style={{borderWidth: "1px", marginTop: "2rem", width: "90%"}} />
                    <button onClick={async () => {
                        let response = await getTicketInfo(agentSliceData.agentAccount, ticketInput, "LookupCase");
                        setTicketSearch(ticketInput);
                        if(response["success"] === "true") {
                            props.setTicket({"ticketFound": "true", "caseNumber": response["CaseNumber"], "comments": response["Comments"], "shortDescription": response["ShortDescription"]});
                            props.setLastAction(Date.now());
                        } else {
                            props.setTicket({"ticketFound": "error", "comments": ""});
                            props.setLastAction(Date.now());
                            props.setAlertDisplay(true);
                        }}
                    } type="button" className="btn btn-primary" style={{}}><MdSearch style={{marginBottom: "0.25rem"}}/> Search</button>
                    {(props.ticket["ticketFound"] === "error") || (props.ticket["ticketFound"] === "false") ? (
                        <></>
                    ):(
                        <div style={{width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center"}}>
                            <div style={{marginTop: "2rem", marginBottom: "2rem", outline: "1px solid #f5f5f5", width: "95%"}}/>
                            <div style={{marginBottom: "3rem"}}>
                                <label className='mb-2' style={{position: "absolute", left: "0", marginLeft: "2rem"}}>Follow-up via:</label>
                            </div>
                            <button onClick={async () => { let result = await sendFollowup(agentSliceData.agentARN, ticketSearch, queueARN, "SMS"); props.setFollowupAlert(true); }} type="button" className="btn btn-success" style={{marginBottom: "1rem", width: "90%"}}><MdOutlineTextsms style={{marginBottom: "0.25rem"}}/> SMS</button>
                            <button onClick={async () => { let result = await sendFollowup(agentSliceData.agentARN, ticketSearch, queueARN, "Email"); props.setFollowupAlert(true); }} type="button" className="btn btn-success" style={{width: "90%"}}><MdOutlineEmail style={{marginBottom: "0.25rem"}}/> Email</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default FollowupsInfo;